document.addEventListener('DOMContentLoaded', function () {

  const stickyBar = document.getElementById('StickyATC');
  const stickyBtn = document.getElementById('StickyATCBtn');

  if (!stickyBar || !stickyBtn) return;

  /* MAIN PRODUCT ADD TO CART BUTTON (drawer wala) */
  const mainATCBtn = document.querySelector(
    'form[action="/cart/add"] button[type="submit"]'
  );

  if (!mainATCBtn) return;

  /* SHOW STICKY ONLY WHEN MAIN ATC NOT VISIBLE */
  function toggleSticky() {
    const rect = mainATCBtn.getBoundingClientRect();
    const visible = rect.top < window.innerHeight && rect.bottom > 0;
    stickyBar.classList.toggle('is-visible', !visible);
  }

  window.addEventListener('scroll', toggleSticky);
  window.addEventListener('resize', toggleSticky);
  toggleSticky();

  /* STICKY CLICK → TRIGGER MAIN ATC (DRAWER OPENS) */
  stickyBtn.addEventListener('click', function () {
    mainATCBtn.click();
  });

});
